import { render, staticRenderFns } from "./Billable.vue?vue&type=template&id=70167a6c&scoped=true"
import script from "./Billable.vue?vue&type=script&lang=js"
export * from "./Billable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70167a6c",
  null
  
)

export default component.exports